export const keys = ['xs', 'sm', 'md', 'lg', 'xl'];
export const values = {
  xs: 0,
  pdfPortrait: 540,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1600,
  xxl: 1800
};

export const print = () => '@media print';

export default {
  values,
  print,
  keys
};
